import { AiSuggestionForReviewCard } from '@/modules/aiSuggestions/aiSuggestions.contracts';
import {
  BUSINESS_ENTITY_KINDS,
  NON_TRUST_CHARITABLE_ENTITY_KINDS,
  TRUST_ENTITY_KINDS,
} from '@/modules/entities/entities.constants';

export type DuplicateTargetKind =
  | 'business'
  | 'charitableVehicle'
  | 'subtrust'
  | 'trust';

export function getDuplicateTargetKind(
  suggestion: AiSuggestionForReviewCard
): DuplicateTargetKind | null {
  if (suggestion.onboardingTestamentaryEntity) {
    return 'subtrust';
  }

  const entityKind = suggestion.onboardingEntity?.entityKind;
  if (!entityKind) {
    return null;
  }
  if (BUSINESS_ENTITY_KINDS.includes(entityKind)) {
    return 'business';
  }
  if (NON_TRUST_CHARITABLE_ENTITY_KINDS.includes(entityKind)) {
    return 'charitableVehicle';
  }
  if (TRUST_ENTITY_KINDS.includes(entityKind)) {
    return 'trust';
  }
  return null;
}

export function getDuplicateTargetLabel(
  targetKind: DuplicateTargetKind
): string {
  if (targetKind === 'business') {
    return 'business entity';
  }
  if (targetKind === 'charitableVehicle') {
    return 'charitable vehicle or organization';
  }
  if (targetKind === 'subtrust') {
    return 'sub-trust';
  }
  return 'trust';
}

export function getDuplicateTargetPluralLabel(
  targetKind: DuplicateTargetKind
): string {
  if (targetKind === 'business') {
    return 'business entities';
  }
  if (targetKind === 'charitableVehicle') {
    return 'charitable vehicles or organizations';
  }
  if (targetKind === 'subtrust') {
    return 'sub-trusts';
  }
  return 'trusts';
}
